import type { FaireProductEntity } from "../../entity_types/product";

export const p_46ysxv63vy: FaireProductEntity = {
  token: "p_46ysxv63vy",
  type: "product",
  name: "Boom Box Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b4072f423bf50a02a42cac75b645a46e83d29da552e26e7216626d9fc62fdb51.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82fcc91989f1b482772a0484909b529253475813781968090c8b400832ccbbb9.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:29.712Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
